/*
 * Rotating reviews in the buy box.
 *
 * One at a time, on a timer, stopping whenever a person is paying attention:
 * a pointer over it, keyboard focus inside it, or the tab in the background.
 * A carousel that keeps moving while someone is reading is worse than none.
 */

(function () {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.querySelectorAll('[data-wake-reviews]').forEach(function (root) {
    const slides = Array.from(root.querySelectorAll('[data-wake-review]'));
    const dots = Array.from(root.querySelectorAll('[data-wake-review-dot]'));
    if (slides.length < 2) return;

    const interval = parseInt(root.dataset.wakeReviewsInterval, 10) || 6000;
    let current = 0;
    let timer = null;

    function show(next) {
      current = (next + slides.length) % slides.length;
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === current);
      });
      dots.forEach(function (dot, i) {
        dot.setAttribute('aria-selected', i === current ? 'true' : 'false');
      });
    }

    function stop() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    function start() {
      /* Nothing moves on its own for anyone who asked for that, and nothing
         ticks away in a tab they cannot see. */
      if (reduced || document.hidden) return;
      stop();
      timer = window.setInterval(function () {
        show(current + 1);
      }, interval);
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        show(i);
        start();
      });
    });

    root.addEventListener('pointerenter', stop);
    root.addEventListener('pointerleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
      else start();
    });

    start();
  });
})();
